<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <mdb-badge class="badge" pill :color="color"
          >{{ label }}
          <span class="close" @click="close($event)">x</span></mdb-badge
        >
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { mdbBadge } from "mdbvue";
export default {
  name: "DtCloseablePadge",
  props: { label: { default: "label" }, color: { default: "green" } },
  methods: {
    close(event) {
      this.$emit("close", event);
    }
  },
  components: { mdbBadge }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.badge {
  position: relative;
  width: 100%;
  font-size: 0.8rem;
  white-space: nowrap;
  padding-right: 25%;
  .close {
    position: absolute;
    color: white;
    right: 8%;
    bottom: 25%;
    font-size: 0.8rem;
    cursor: pointer;
  }
}
</style>
